import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { writeTenantCookie } from './tenantCookie';
import { TenantContext } from './types';

type TenantContextState = {
  context: TenantContext;
  setContext: (next: TenantContext) => void;
};

const TenantContextStateContext = createContext<TenantContextState | null>(null);

export const TenantContextProvider = ({ initial, children }: { initial: TenantContext; children: React.ReactNode }) => {
  const [context, setContextState] = useState<TenantContext>(initial);
  const setContext = useCallback((next: TenantContext) => {
    writeTenantCookie(next);
    setContextState(next);
  }, []);
  const value = useMemo(() => ({ context, setContext }), [context, setContext]);
  return <TenantContextStateContext.Provider value={value}>{children}</TenantContextStateContext.Provider>;
};

export function useTenantContextValue(): TenantContextState {
  const value = useContext(TenantContextStateContext);
  if (!value) {
    throw new Error('useTenantContextValue must be used within TenantContextProvider');
  }
  return value;
}
